











import Vue from "vue";
import "@/lib/extentions";
import CloseCircleIcon from "@/components/atoms/CloseCircleIcon.vue";

export default Vue.extend<{}, {}, Computed, Props>({
  components: { CloseCircleIcon },
  computed: {
    style() {
      return {
        borderRadius: `${this.radius}px`,
        fontSize: `${this.fontSize}px`,
        padding: `${this.paddingVertical}px ${this.paddingHorizontal}px`,
      };
    },
    text() {
      return this.value.addEllipsis(this.maxLength);
    },
  },
  props: {
    value: {
      type: String,
      required: true,
      default: "",
    },
    item: {
      type: Object,
    },
    radius: {
      type: Number,
      default: 25,
    },
    fontSize: {
      type: Number,
      default: 10,
    },
    iconSize: {
      type: Number,
      default: 20,
    },
    iconColor: {
      type: String,
      default: "#4b4b4b",
    },
    paddingHorizontal: {
      type: Number,
      default: 8,
    },
    paddingVertical: {
      type: Number,
      default: 4,
    },
    maxLength: {
      type: Number,
      default: 4,
    },
    onDelete: {
      type: Function,
    },
  },
});

interface Computed {
  style: { [key: string]: string };
  text: string;
}

interface Props {
  value: string;
  item: any;
  radius: number;
  fontSize: number;
  iconSize: number;
  iconColor: string;
  paddingHorizontal: number;
  paddingVertical: number;
  maxLength: number;
  onDelete: (item: any) => void;
}
